import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HelperService } from '../../core';
import { OrganizationService } from '../../shared';
import { StopSmulationDialogComponent } from '../../shared/dialogs/stop-simulation-dialog/stop-simulation-dialog.component';
import { SimulationService } from '../services';
import { SimulationData, SIMULATION_STATUS } from '../types';
import { AddSimulationFormComponent } from './dialog/add-simulation-form.component';
import { ParticipantsFormComponent } from './dialog/participants-form.component';
import { StartSimulationFormComponent } from './dialog/start-simulation-form.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../core/auth/services/auth.service';
import { ShareSimulationService } from '../../shared/services/share-simulation.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { calculateDurationEnded } from '../../utils/duration-date';

@Component({
    selector: 'simulation-list',
    templateUrl: './simulation-list.component.html',
    styleUrls: ['./simulation-list.component.scss'],
})
export class SimulationListComponent implements OnInit, AfterViewInit {
    createdBy: any;
    orgId: any = null;
    ENUM_STATUS: any;
    listOrganization = [];
    displayedColumns: string[] = [
        'simulationName',
        'code',
        'status',
        'participant',
        'type',
        'room',
        'availability',
        'min',
        'datetime',
        'copy',
        'action',
    ];
    dataSource = new MatTableDataSource<SimulationData>();
    activePage = 1;
    pageSize = 20;
    totalItems = 0;
    maxPage: any = 0;

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private helperService: HelperService,
        private organizationsService: OrganizationService,
        private simulationService: SimulationService,
        private ngxService: NgxUiLoaderService,
        private translate: TranslateService,
        private _snackBar: MatSnackBar,
        private authService: AuthService,
        private shareServiver: ShareSimulationService,
    ) {
        // Make a variable reference to our Enum
        this.ENUM_STATUS = SIMULATION_STATUS;
        this.createdBy = this.authService.userAttrs?.sub ?? '';
    }

    get isSimuAdmin() {
        return this.authService.isSimuAdmin;
    }

    ngOnInit() {
        this.refreshDataTable(true);
        this.getMyOrg();
    }

    ngAfterViewInit() {}

    onFirstPageClick() {
        this.paginate(1);
    }

    onLastPageClick() {
        this.paginate(this.maxPage);
    }

    paginate(event: any) {
        this.activePage = event;
        this.refreshDataTable(true);
    }

    openAddSimulationForm() {
        const data = {
            organizations: this.listOrganization,
        };
        let modal = this.dialog.open(AddSimulationFormComponent, {
            data,
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            autoFocus: false,
            panelClass: 'position-relative',
        });

        modal.afterClosed().subscribe(data => {
            if (data == 'OK') {
                this.refreshDataTable(true);
            }
        });
    }
    openEditSimulationForm(data: any) {
        const dialogData = {
            organizations: this.listOrganization,
            simulation: data,
        };
        let modal = this.dialog.open(AddSimulationFormComponent, {
            data: dialogData,
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            autoFocus: false,
            panelClass: 'position-relative',
        });

        modal.afterClosed().subscribe(data => {
            if (data == 'OK') {
                this.refreshDataTable(true);
            }
        });
    }

    openParticipantForm = (data: any) => {
        this.dialog.open(ParticipantsFormComponent, {
            data,
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            panelClass: 'position-relative',
        });
    };

    openStartSimulationForm(data: any) {
        this.dialog.open(StartSimulationFormComponent, {
            data,
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            panelClass: 'position-relative',
        });
    }

    getTemplateDateTime = (data: any) => {
        return this.helperService.getTemplateDateTime(data.startDate);
    };

    btnClickAction = (type: any, dataRow: any) => {
        switch (type) {
            case 'edit':
                this.openEditSimulationForm(dataRow);
                break;
            case 'start now':
                this.openStartSimulationForm(dataRow);
                break;
            case 'join':
                this.router.navigateByUrl(`/simulation-started?simulationId=${dataRow.id}`);
                break;
            case 'view log':
                this.router.navigateByUrl(`/simulation-started?simulationId=${dataRow.id}&action=edit`);
                break;
            case 'Download PDF':
                this.downloadHistory(dataRow.id);
                break;
            case 'stop':
                this.openStopSimulationForm(dataRow);
                break;
            //start now
            default:
                this.openStartSimulationForm(dataRow);
                break;
        }
    };

    openStopSimulationForm(data: any) {
        this.dialog.open(StopSmulationDialogComponent, {
            data,
            width: '470px',
            height: '261px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });
    }

    getMyOrg() {
        this.organizationsService.getMyOrganization().subscribe(result => {
            if (result && result.data) {
                this.listOrganization = result.data;
            }
        });
    }

    onChangeOrg(orgId: any) {
        this.orgId = orgId;
        this.refreshDataTable(true);
    }

    refreshDataTable(isInnit: boolean) {
        if (isInnit) {
            this.ngxService.start();
        }

        let parram: any = {
            pageIndex: this.activePage - 1,
            pageSize: this.pageSize,
        };

        if (this.orgId) {
            parram = {
                organizationId: this.orgId,
                pageIndex: this.activePage - 1,
                pageSize: this.pageSize,
            };
        }

        this.simulationService.getListSimulation(parram).subscribe(
            res => {
                this.totalItems = res.total;
                this.maxPage = Math.ceil(this.totalItems / this.pageSize);
                this.dataSource.data = res.data;
                if (isInnit) {
                    this.ngxService.stop();
                }
            },
            () => {
                if (isInnit) {
                    this.ngxService.stop();
                }
            },
        );
    }

    formatCell(type: any, dataRow: any) {
        if (type == 'availability') {
            if (dataRow?.status == this.ENUM_STATUS.NOT_STARTED || dataRow?.status == this.ENUM_STATUS.ENDED) {
                return `${dataRow.participantLogAvailable} Days`;
            } else if (dataRow?.status == this.ENUM_STATUS.RUNNING) {
                return `-`;
            }
        }
    }

    formatCellParticipant = (value: any) => {
        if (value) {
            return `${value.length} ${this.translate.instant('Text_Participants')}`;
        }
        return `0 ${this.translate.instant('Text_Participants')}`;
    };

    formMatCellMin(element: any) {
        if (element.startAtTime && element.endDate) {
            return calculateDurationEnded(element.startAtTime, element.endDate);
        }
        return '-';
    }

    copyToClipboard(url: string) {
        navigator.clipboard.writeText(url);
        this._snackBar.open(this.translate.instant('CopySuccess'), 'x', {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['copy-successfully-snackbar'],
            duration: 1000,
        });
    }
    downloadHistory(id: string) {
        this.shareServiver
            .share(Number(id))
            .subscribe(async res => {
                let html = res.parameters.contentHtml;
                const parser = new DOMParser();
                const document123 = parser.parseFromString(html, 'text/html');
                const div = document.createElement('div');
                div.setAttribute('id', 'pdf-image');
                div.appendChild(document123.body);
                document.body.prepend(div);
                html2canvas(document.getElementById('pdf-image')?.firstChild as any).then(async canvas => {
                    let fileWidth = 208;
                    let fileHeight = (canvas.height * fileWidth) / canvas.width;
                    const FILEURI = canvas.toDataURL('image/png');
                    let PDF = new jsPDF('p', 'mm', 'a4');
                    let position = 0;
                    PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight, undefined, 'FAST');
                    PDF.save(`${Number(id)}.pdf`);
                    document.body.removeChild(div);
                });
            });
    }
}
